module.exports = __webpack_public_path__ + "40e9790328d4f312157f41b7ffa611ae.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/trophy-shelf-1.png
// module id = 339
// module chunks = 0